var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"arrow-container"},[_c('span',{staticClass:"arrow"})])
}]
render._withStripped = true
export { render, staticRenderFns }